"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.doQuoteRemake = exports.doQuoteTransform = exports.doQuoteDetail = exports.doQuoteDownload = exports.doQuoteCatalogRV = exports.doQuoteCatalog = exports.doQuotesList = exports.doQuoteSave = void 0;
const async_storage_1 = __importDefault(require("@react-native-async-storage/async-storage"));
const constants_1 = require("constants/constants");
const api_1 = __importDefault(require("constants/api"));
const doQuoteSave = async ({ params, callback, }) => {
    const loginDataStr = await async_storage_1.default.getItem(constants_1.StorageKey.LOGIN_DATA);
    const loginDataJSON = JSON.parse(loginDataStr ?? "{}");
    var formData = new FormData();
    formData.append("data", JSON.stringify({
        op: "cliente.cotizaciones.save",
        token: loginDataJSON.token,
        cliid: params?.cliid,
        tipo: params?.tipo ?? "coti",
        data: {
            cliente: params?.data?.cliente,
            comentario: params?.data?.comentario,
            almacen: params?.data?.almacen,
        },
    }));
    callback?.onLoading?.(true);
    fetch(api_1.default.URL_BASE, {
        method: "POST",
        headers: {
            ...api_1.default.HEADER_BASIC_AUTH,
        },
        body: formData,
    })
        .then(response => response?.json())
        .then(json => {
        switch (json.status) {
            case api_1.default.WS_STATUS_SUCCESS:
                callback?.onSuccess(json);
                break;
            default:
                if (json?.reason == api_1.default.REASON_SESSION_EXIPIRED)
                    callback?.onFailSessionExpired?.();
                callback?.onFail?.(json.msg);
                break;
        }
        callback?.onLoading?.(false);
    })
        .catch(error => {
        console.error(error);
        callback?.onFail?.("Error!");
        callback?.onLoading?.(false);
    });
};
exports.doQuoteSave = doQuoteSave;
const doQuotesList = async ({ params, callback, }) => {
    const loginDataStr = await async_storage_1.default.getItem(constants_1.StorageKey.LOGIN_DATA);
    const loginDataJSON = JSON.parse(loginDataStr ?? "{}");
    var formData = new FormData();
    formData.append("data", JSON.stringify({
        op: "cliente.cotizaciones.list",
        token: loginDataJSON.token,
        data: {
            uid: loginDataJSON?.uid,
            q: params?.data?.q,
            page: params?.data?.page,
        },
    }));
    callback?.onLoading?.(true);
    fetch(api_1.default.URL_BASE, {
        method: "POST",
        headers: {
            ...api_1.default.HEADER_BASIC_AUTH,
        },
        body: formData,
    })
        .then(response => response?.json())
        .then(json => {
        switch (json.status) {
            case api_1.default.WS_STATUS_SUCCESS:
                callback?.onSuccess(json);
                break;
            default:
                if (json?.reason == api_1.default.REASON_SESSION_EXIPIRED)
                    callback?.onFailSessionExpired?.();
                callback?.onFail?.(json.msg);
                break;
        }
        callback?.onLoading?.(false);
    })
        .catch(error => {
        console.error(error);
        callback?.onFail?.("Error!");
        callback?.onLoading?.(false);
    });
};
exports.doQuotesList = doQuotesList;
const doQuoteDetail = async ({ params, callback, }) => {
    const loginDataStr = await async_storage_1.default.getItem(constants_1.StorageKey.LOGIN_DATA);
    const loginDataJSON = JSON.parse(loginDataStr ?? "{}");
    var formData = new FormData();
    formData.append("data", JSON.stringify({
        op: "cliente.cotizaciones.get",
        token: loginDataJSON.token,
        data: {
            cotid: params?.data?.cotid,
        },
    }));
    callback?.onLoading?.(true);
    fetch(api_1.default.URL_BASE, {
        method: "POST",
        headers: {
            ...api_1.default.HEADER_BASIC_AUTH,
        },
        body: formData,
    })
        .then(response => response?.json())
        .then(json => {
        switch (json.status) {
            case api_1.default.WS_STATUS_SUCCESS:
                callback?.onSuccess(json);
                break;
            default:
                if (json?.reason == api_1.default.REASON_SESSION_EXIPIRED)
                    callback?.onFailSessionExpired?.();
                callback?.onFail?.(json.msg);
                break;
        }
        callback?.onLoading?.(false);
    })
        .catch(error => {
        console.error(error);
        callback?.onFail?.("Error!");
        callback?.onLoading?.(false);
    });
};
exports.doQuoteDetail = doQuoteDetail;
const doQuoteCatalog = async ({ params, callback, }) => {
    const loginDataStr = await async_storage_1.default.getItem(constants_1.StorageKey.LOGIN_DATA);
    const loginDataJSON = JSON.parse(loginDataStr ?? "{}");
    var formData = new FormData();
    formData.append("data", JSON.stringify({
        op: "catalog.cotizacion",
        token: loginDataJSON?.token,
        data: {
            uid: params?.data.uid,
            uidtipo: loginDataJSON?.uidtipo,
            almacen: params?.data?.almacen,
            page: params?.data?.page,
            q: params?.data?.q,
        },
    }));
    callback?.onLoading?.(true);
    fetch(api_1.default.URL_BASE, {
        method: "POST",
        headers: {
            ...api_1.default.HEADER_BASIC_AUTH,
        },
        body: formData,
    })
        .then(response => response?.json())
        .then(json => {
        switch (json.status) {
            case api_1.default.WS_STATUS_SUCCESS:
                callback?.onSuccess(json);
                break;
            default:
                if (json?.reason == api_1.default.REASON_SESSION_EXIPIRED)
                    callback?.onFailSessionExpired?.();
                callback?.onFail?.(json.msg);
                break;
        }
        callback?.onLoading?.(false);
    })
        .catch(error => {
        console.error(error);
        callback?.onFail?.("Error!");
        callback?.onLoading?.(false);
    });
};
exports.doQuoteCatalog = doQuoteCatalog;
const doQuoteCatalogRV = async ({ params, callback, }) => {
    const loginDataStr = await async_storage_1.default.getItem(constants_1.StorageKey.LOGIN_DATA);
    const loginDataJSON = JSON.parse(loginDataStr ?? "{}");
    var formData = new FormData();
    formData.append("data", JSON.stringify({
        op: "catalog.cotizacion.rv",
        token: loginDataJSON?.token,
        data: {
            docEntry: params?.data.docEntry,
            lineId: params?.data?.lineId,
            page: params?.data?.page,
            q: params?.data?.q,
        },
    }));
    callback?.onLoading?.(true);
    fetch(api_1.default.URL_BASE, {
        method: "POST",
        headers: {
            ...api_1.default.HEADER_BASIC_AUTH,
        },
        body: formData,
    })
        .then(response => response?.json())
        .then(json => {
        switch (json.status) {
            case api_1.default.WS_STATUS_SUCCESS:
                callback?.onSuccess(json);
                break;
            default:
                if (json?.reason == api_1.default.REASON_SESSION_EXIPIRED)
                    callback?.onFailSessionExpired?.();
                callback?.onFail?.(json.msg);
                break;
        }
        callback?.onLoading?.(false);
    })
        .catch(error => {
        console.error(error);
        callback?.onFail?.("Error!");
        callback?.onLoading?.(false);
    });
};
exports.doQuoteCatalogRV = doQuoteCatalogRV;
const doQuoteDownload = async ({ params, callback, }) => {
    const loginDataStr = await async_storage_1.default.getItem(constants_1.StorageKey.LOGIN_DATA);
    const loginDataJSON = JSON.parse(loginDataStr ?? "{}");
    var formData = new FormData();
    formData.append("data", JSON.stringify({
        op: "cliente.cotizacion.download",
        token: loginDataJSON?.token,
        data: {
            cotiid: params?.data?.cotiid,
        },
    }));
    callback?.onLoading?.(true);
    fetch(api_1.default.URL_BASE, {
        method: "POST",
        headers: {
            ...api_1.default.HEADER_BASIC_AUTH,
        },
        body: formData,
    })
        .then(response => response?.blob())
        .then(blob => {
        callback?.onSuccess(blob);
        callback?.onLoading?.(false);
    })
        .catch(error => {
        console.error(error);
        callback?.onFail?.("Error!");
        callback?.onLoading?.(false);
    });
};
exports.doQuoteDownload = doQuoteDownload;
const doQuoteTransform = async ({ params, callback, }) => {
    const loginDataStr = await async_storage_1.default.getItem(constants_1.StorageKey.LOGIN_DATA);
    const loginDataJSON = JSON.parse(loginDataStr ?? "{}");
    var formData = new FormData();
    formData.append("data", JSON.stringify({
        op: "cliente.cotizacion.transform",
        token: loginDataJSON?.token,
        data: {
            cotid: params?.data.cotid,
            cliid: params?.data.cliid,
            almacen: params?.data?.almacen,
        },
    }));
    callback?.onLoading?.(true);
    fetch(api_1.default.URL_BASE, {
        method: "POST",
        headers: {
            ...api_1.default.HEADER_BASIC_AUTH,
        },
        body: formData,
    })
        .then(response => response?.json())
        .then(json => {
        switch (json.status) {
            case api_1.default.WS_STATUS_SUCCESS:
                callback?.onSuccess(json);
                break;
            default:
                if (json?.reason == api_1.default.REASON_SESSION_EXIPIRED)
                    callback?.onFailSessionExpired?.();
                callback?.onFail?.(json.msg);
                break;
        }
        callback?.onLoading?.(false);
    })
        .catch(error => {
        console.error(error);
        callback?.onFail?.("Error!");
        callback?.onLoading?.(false);
    });
};
exports.doQuoteTransform = doQuoteTransform;
const doQuoteRemake = async ({ params, callback, }) => {
    const loginDataStr = await async_storage_1.default.getItem(constants_1.StorageKey.LOGIN_DATA);
    const loginDataJSON = JSON.parse(loginDataStr ?? "{}");
    var formData = new FormData();
    formData.append("data", JSON.stringify({
        op: "cliente.cotizacion.recall",
        token: loginDataJSON?.token,
        data: {
            cotid: params?.data.cotid,
        },
    }));
    callback?.onLoading?.(true);
    fetch(api_1.default.URL_BASE, {
        method: "POST",
        headers: {
            ...api_1.default.HEADER_BASIC_AUTH,
        },
        body: formData,
    })
        .then(response => response?.json())
        .then(json => {
        switch (json.status) {
            case api_1.default.WS_STATUS_SUCCESS:
                callback?.onSuccess(json);
                break;
            default:
                if (json?.reason == api_1.default.REASON_SESSION_EXIPIRED)
                    callback?.onFailSessionExpired?.();
                callback?.onFail?.(json.msg);
                break;
        }
        callback?.onLoading?.(false);
    })
        .catch(error => {
        console.error(error);
        callback?.onFail?.("Error!");
        callback?.onLoading?.(false);
    });
};
exports.doQuoteRemake = doQuoteRemake;
